// extracted by mini-css-extract-plugin
export default {"container":"FileCopy_container__6uQvk","link":"FileCopy_link__mFljx","filter":"FileCopy_filter__aOQUH","filterSmall":"FileCopy_filterSmall__4UR74"};